import BaseAbility from 'umg-ember-backend/abilities/base';

export default class MlpStagePlusStreamAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('content-item');
  }
}
